var map = {
	"./auth-background.webp": 1918,
	"./close-btn.webp": 1919,
	"./icon-caution.webp": 1920,
	"./icon-checked.webp": 1921,
	"./icon-contact-us.webp": 1922,
	"./icon-email.webp": 1923,
	"./icon-eye-close.webp": 1924,
	"./icon-eye-open.webp": 1925,
	"./icon-forget-phone.webp": 1926,
	"./icon-forget-whatsapp.webp": 1927,
	"./icon-google.webp": 1928,
	"./icon-login-email-2.webp": 1929,
	"./icon-login-email.webp": 1930,
	"./icon-password.webp": 1931,
	"./icon-robot-select.webp": 1932,
	"./icon-robot-unselect.webp": 1933,
	"./icon-telegram.webp": 1934,
	"./icon-user.webp": 1935,
	"./jackpot-cn.webp": 1936,
	"./jackpot-mobile-cn.webp": 1937,
	"./jackpot-mobile-ms.webp": 1938,
	"./jackpot-mobile.webp": 1939,
	"./jackpot-ms.webp": 1940,
	"./jackpot.webp": 1941,
	"./login-bg.webp": 1942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;